import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const POS_SUCCESS = 'POS_SUCCESS';
export const POS_LOADING = 'POS_LOADING';

const { posNew: { getPosNew } } = apiUrls;


export const getPOSDetailsNew = () => async (dispatch) => {
  try {
// console.log(bodyData)
    const requestData = {
        ...getPosNew,
        url: getPosNew.url,
    };
    const data = await REQUEST(requestData);
    dispatch({
      type: POS_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: POS_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: POS_LOADING,
    isLoading
  })
}
